'use strict';
import axios from 'axios';
import ENV from '../environtment'

const baseUrl = ENV.api
const costumHeader = ENV.costumHeader

const actions = {
  getCompanyWithUserCount(context, params = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/company/listwithusercount`
        const result = await axios.get(url, {
          ...costumHeader('Get Company Count', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve([])
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve([])
      }
    })
  },
  getCompanyList(context, params = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/company/list`
        const result = await axios.get(url, {
          ...costumHeader('Get Company', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve([])
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve([])
      }
    })
  },
  saveMasterHolidayCopy(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/master_holiday/copy`
        const result = await axios.post(url, body, costumHeader('Copy Master Holiday', 1))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  saveCompanyData(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/company/add`
        const result = await axios.post(url, body, costumHeader('Save Company Data', 1))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  saveClientData(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/client/add`
        const result = await axios.post(url, body, costumHeader('Save Client Data', 1))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  editCompanyData(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/company/edit`
        const result = await axios.post(url, body, costumHeader('Edit Company Data', 2))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
}

export default { actions }